import { getStatusProps } from 'components/ServerStatusBadgeFlat';
import type { AssetDetails } from 'modules/queries/asset/useDetails';

/**
 * The list item color for a server's status, limited to the states that should
 * tint the row.
 */
const getRowColor = ({
	status,
	powerStatus,
}: Pick<AssetDetails, 'status' | 'powerStatus'>) => {
	const { color } = getStatusProps({ status, powerStatus });

	if (color === 'danger' || color === 'warning') {
		return color;
	}

	return undefined;
};

export default getRowColor;
